module.exports = "/_next/static/images/complaint-mediation-21ac3d9170546b9e744eb40ff6b1e883.png";